import { render, staticRenderFns } from "./MfStonks.vue?vue&type=template&id=07aae994&scoped=true"
import script from "./MfStonks.vue?vue&type=script&lang=js"
export * from "./MfStonks.vue?vue&type=script&lang=js"
import style0 from "./MfStonks.vue?vue&type=style&index=0&id=07aae994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aae994",
  null
  
)

export default component.exports